<template>
    <div>
        <img :src="'/media/header/locker-room.jpg'" alt="Locker Room" class="img-fluid mb-4 rounded">
<!--        <page-header :title="$t('pages.locker.title')" icon-class="mdi mdi-google-classroom"/>-->

        <div class="row mb-4">
            <div class="col-12">
                <nav class="nav nav-pills nav-justified oswald">
                    <router-link tag="a" :to="link.route" class="nav-item nav-link ml-1 mr-1 shadow-sm" href="#"
                                 :class="{active: isActive(link), 'bg-white text-primary': !isActive(link), 'text-primary': !isActive(link), 'text-white': isActive(link)}"
                                 v-for="link in links" :key="link.title">
                        {{ link.title }}
                    </router-link>
                </nav>
            </div>
        </div>

        <div class="row mb-4">

            <div class="col-md-12">
                <transition name="component-fade" mode="out-in">
                    <router-view></router-view>
                </transition>
            </div>
        </div>

    </div>
</template>

<script>
import PageHeader from "../Includes/PageHeader";
export default {
    name: "LockerRoom",
    components: {PageHeader},
    computed: {
        links() {
            return [
                {
                    title: this.$t('pages.locker.get_aform.title'),
                    route: {name: 'locker.get-aform'},
                    activeWord:'get-aform'
                },
                {
                    icon: 'mdi-account',
                    title: this.$t('pages.locker.my_aform.title'),
                    route: {name: 'locker.my-aform'},
                    activeWord: 'my-aform'
                },
                {
                    title: this.$t('pages.locker.my_coach.title'),
                    route: {name: 'locker.my-coach'},
                    activeWord:'my-coach'
                },
                {
                    title: this.$t('pages.locker.my_blog.title'),
                    route: {name: 'locker.my-blog'},
                    activeWord:'my-blog'
                },
            ];
        }
    },
    methods: {
        isActive(link) {
            if(link.activeWord === undefined)
                return (this.$route.name === link.route.name);

            return this.$route.name.includes(link.activeWord);
        }
    }

}
</script>

<style scoped>
</style>
